import React from 'react';

import { Icon } from '@eduzz/ui-antd-theme';

type RouteNode = {
  to: string;
  label: string;
  permission?: string;
  isUnityExclusive?: boolean;
  betaModule?: string;
  tour?: string;
};

export type Route = {
  to?: string;
  label: string;
  icon?: React.ReactNode;
  nodes?: RouteNode[];
  permission?: string;
  userTypes?: string[];
  isUnityExclusive?: boolean;
  accessPerBelt?: number[];
  betaModule?: string;
  tour?: string;
  external?: boolean;
};

const routes: Route[] = [
  {
    to: '/producer/dashboard',
    label: 'Dashboard',
    icon: <Icon.LayoutDashboard size={24} className='size-6 text-2xl'  />
  },
  {
    to: '/producer/shopping',
    label: 'Compras',
    icon: <Icon.DollarSign size={24} className='size-6 text-2xl'  />,
    userTypes: ['onlyCustomer']
  },
  {
    label: 'Vendas',
    icon: <Icon.ShoppingCart size={24} className='size-6 text-2xl'  />,
    userTypes: ['producer', 'affiliate'],
    nodes: [
      {
        to: '/producer/sales',
        label: 'Minhas Vendas',
        permission: 'myeduzz:minhas-vendas:visualizar'
      },
      {
        to: '/producer/leads',
        label: 'Meus Leads',
        permission: 'myeduzz:meus-leads:visualizar'
      },
      {
        to: '/producer/myaffiliates',
        label: 'Meus Afiliados',
        permission: 'myeduzz:meus-afiliados:visualizar'
      },
      {
        to: '/producer/orders',
        label: 'Minhas Entregas',
        permission: 'myeduzz:minhas-entregas:visualizar'
      },
      {
        to: '/producer/whitelist',
        label: 'Whitelist',
        permission: 'myeduzz:whitelist:visualizar'
      },
      {
        to: '/producer/request-management',
        label: 'Ações Pendentes',
        permission: 'myeduzz:request-management:visualizar'
      }
    ]
  },
  {
    label: 'Produtos',
    icon: <Icon.FolderOpen size={24} className='size-6 text-2xl'  />,
    userTypes: ['producer', 'affiliate'],
    nodes: [
      {
        to: '/producer/product/myproducts',
        label: 'Meus Produtos',
        permission: 'myeduzz:meus-produtos:visualizar'
      },
      {
        to: '/producer/affiliations',
        label: 'Minhas Afiliações',
        permission: 'myeduzz:meus-afiliados:visualizar'
      },
      {
        to: '/producer/campaigns',
        label: 'Links',
        permission: 'myeduzz:links:visualizar'
      }
    ]
  },
  {
    label: 'Financeiro',
    icon: <Icon.DollarSign size={24} className='size-6 text-2xl'  />,
    userTypes: ['producer', 'affiliate'],
    nodes: [
      {
        to: '/producer/financial-statement',
        label: 'Extrato',
        permission: 'myeduzz:financeiro:visualizar'
      }
    ]
  },
  {
    to: '/producer/reports/sales',
    label: 'Relatórios',
    icon: <Icon.ChartColumn size={24} className='size-6 text-2xl'  />,
    userTypes: ['producer'],
    tour: 'new_sales_reports',
    permission: 'myeduzz:reports:visualizar'
  },
  {
    to: 'https://space.eduzz.com',
    label: 'Soluções',
    icon: <Icon.Lightbulb size={24} className='size-6 text-2xl'  />,
    userTypes: ['producer', 'affiliate'],
    permission: 'no-access-control-permission',
    external: true
  },
  {
    label: 'Integrações',
    icon: <Icon.Settings size={24} className='size-6 text-2xl'  />,
    userTypes: ['producer', 'affiliate'],
    nodes: [
      {
        to: '/producer/config-api',
        label: 'Configurações da API',
        permission: 'no-access-control-permission'
      },
      {
        to: '/producer/cdf',
        label: 'Central de Documentos Fiscais',
        permission: 'myeduzz:cdf:visualizar'
      },
      {
        to: '/producer/connect/myconnects',
        label: 'Connect',
        permission: 'myeduzz:connect:visualizar'
      },
      {
        to: '/producer/new-connect',
        label: 'Novo Connect',
        permission: 'myeduzz:connect:visualizar',
        betaModule: 'new_connect'
      },
      {
        to: '/producer/webhook',
        label: 'Webhooks',
        permission: 'myeduzz:webhook:visualizar'
      }
    ]
  },
  {
    label: 'Configurações',
    icon: <Icon.SlidersHorizontal size={24} className='size-6 text-2xl'  />,
    userTypes: ['producer'],
    nodes: [
      {
        to: '/producer/access',
        label: 'Controle de Acesso',
        permission: 'no-access-control-permission'
      }
    ]
  },
  {
    to: '/producer/help',
    label: 'Ajuda',
    icon: <Icon.CircleHelp size={24} className='size-6 text-2xl'  />,
    permission: 'myeduzz:ajuda:visualizar'
  }
];

export { routes };
